import { COMPANY } from './company';

export const cookiePolicy = {
  tr: {
    title: 'Çerez Politikası',
    intro: `Bu politika, ${COMPANY.website} web sitesinde kullanılan çerezleri ve tercihlerinizi nasıl yönetebileceğinizi açıklar.`,
    sections: [
      {
        heading: 'Çerez Nedir?',
        body: ['Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınıza kaydedilen küçük metin dosyalarıdır. Sitenin düzgün çalışmasını, tercihlerinizin hatırlanmasını ve kullanımın analiz edilmesini sağlar.'],
      },
      {
        heading: 'Kullandığımız Çerez Türleri',
        items: [
          'Gerekli çerezler: Sitenin temel işlevleri ve çerez tercihlerinizin saklanması için zorunludur; kapatılamaz.',
          'İşlevsel çerezler: İçerik paylaşımı gibi ek özellikleri mümkün kılar.',
          'Analitik çerezler: Ziyaretçilerin siteyi nasıl kullandığını anlamamıza yardımcı olur.',
          'Performans çerezleri: Sitenin hız ve performans göstergelerini ölçer.',
          'Reklam çerezleri: Daha önce ziyaret ettiğiniz sayfalara göre size uygun reklamlar gösterilmesini sağlar.',
        ],
      },
      {
        heading: 'Rıza ve Hukuki Sebep',
        body: ['Gerekli çerezler meşru menfaatimiz ve sitenin çalışması için kullanılır. Diğer tüm çerezler yalnızca çerez bildirimindeki onayınızla etkinleşir ve onayınızı dilediğiniz zaman geri çekebilirsiniz.'],
      },
      {
        heading: 'Üçüncü Taraf Çerezleri',
        body: ['Randevu planlama (Google Takvim) gibi üçüncü taraf hizmetlere yönlendirildiğinizde, bu hizmetler kendi çerezlerini kullanabilir. Bu çerezler ilgili sağlayıcıların politikalarına tabidir.'],
      },
      {
        heading: 'Tercihlerinizi Yönetme',
        items: [
          'Sayfanın sağ alt köşesindeki çerez simgesine tıklayarak tercihlerinizi istediğiniz zaman değiştirebilirsiniz.',
          'Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz; bu durumda sitenin bazı bölümleri düzgün çalışmayabilir.',
        ],
      },
      {
        heading: 'Saklama Süresi',
        body: ['Çerez tercihleriniz, siz silene veya değiştirene kadar tarayıcınızda saklanır. Diğer çerezlerin süreleri türlerine göre oturum süresinden birkaç aya kadar değişebilir.'],
      },
      {
        heading: 'İletişim',
        body: [`Çerezlerle ilgili sorularınız için ${COMPANY.email} adresinden bize ulaşabilirsiniz.`],
      },
    ],
  },
  en: {
    title: 'Cookie Policy',
    intro: `This policy explains the cookies used on ${COMPANY.website} and how you can manage your preferences.`,
    sections: [
      {
        heading: 'What Are Cookies?',
        body: ['Cookies are small text files saved in your browser when you visit a website. They keep the site working, remember your preferences and help analyse usage.'],
      },
      {
        heading: 'Types of Cookies We Use',
        items: [
          'Necessary cookies: required for core site functions and for storing your cookie preferences; they cannot be switched off.',
          'Functional cookies: enable extra features such as sharing content.',
          'Analytics cookies: help us understand how visitors use the site.',
          'Performance cookies: measure the site\'s speed and performance indicators.',
          'Advertisement cookies: show you relevant ads based on pages you visited before.',
        ],
      },
      {
        heading: 'Consent and Legal Basis',
        body: ['Necessary cookies are used on the basis of our legitimate interest and to run the site. All other cookies are enabled only with your consent through the cookie banner, and you can withdraw it at any time.'],
      },
      {
        heading: 'Third-Party Cookies',
        body: ['When you are redirected to third-party services such as appointment booking (Google Calendar), those services may set their own cookies, which are governed by their providers\' policies.'],
      },
      {
        heading: 'Managing Your Preferences',
        items: [
          'Click the cookie icon at the bottom-right of the page to change your preferences at any time.',
          'You can delete or block cookies in your browser settings; some parts of the site may then not work properly.',
        ],
      },
      {
        heading: 'Retention',
        body: ['Your cookie preferences are stored in your browser until you delete or change them. Other cookies last from a single session to several months depending on their type.'],
      },
      {
        heading: 'Contact',
        body: [`For questions about cookies, reach us at ${COMPANY.email}.`],
      },
    ],
  },
};
